<mat-card>
  <mat-card-header>
    <mat-card-title>Download</mat-card-title>
  </mat-card-header>
  <mat-card-content>

    <mat-list>
      <h3 mat-subheader>aktuelle Reisen</h3>

      <mat-list-item>
        <mat-icon mat-list-icon>photo</mat-icon>
        <a href="/assets/download/Flyer_25_26.pdf" target="_blank">Flyer 2025/2026</a>
      </mat-list-item>

      <mat-list-item>
        <mat-icon mat-list-icon>photo</mat-icon>
          <a href="/assets/download/Board-Karte_26.jpeg" target="_blank">Board-Karte</a>
      </mat-list-item>

      <mat-divider></mat-divider>

      <h3 mat-subheader>Rechtliches</h3>

      <mat-list-item>
        <mat-icon mat-list-icon>note</mat-icon>
        <a href="/assets/download/Allgemeine_Reisebedingungen_Mehrtagesreisen_Friedel_Reisen_Stand_14.02.2019.pdf" target="_blank">Reisebedingungen der Friedel Reisen GbR</a>
      </mat-list-item>

      <mat-list-item>
        <mat-icon mat-list-icon>note</mat-icon>
        <a href="/assets/download/Haftungsausschlusserklaerung_Guiding_2018.pdf" target="_blank">Haftungsausschlusserklärung für „Private Guiding“</a>
      </mat-list-item>

      <mat-list-item>
        <mat-icon mat-list-icon>note</mat-icon>
        <a href="/assets/download/U18_Erklaerung.pdf" target="_blank">Einverständniserklärung für Reiseteilnehmer unter 18 Jahren</a>
      </mat-list-item>
    </mat-list>

  </mat-card-content>
</mat-card>
